import React from 'react';
import CodeBlock from '@/components/CodeBlock/CodeBlock';

const HTMLInputTypes = () => {
    const inputTextCode = `<label for="username">Username:</label>
<input type="text" 
       id="username" 
       name="username" 
       placeholder="Enter username"
       maxlength="50"
       required>

<!-- Common attributes: --&gt;
<!-- placeholder: Hint text --&gt;
<!-- maxlength: Maximum character count --&gt;
<!-- minlength: Minimum character count --&gt;
<!-- pattern: Regex validation --&gt;
<!-- required: Field is mandatory --&gt;`;

    const inputEmailCode = `<label for="email">Email:</label>
<input type="email" 
       id="email" 
       name="email" 
       placeholder="you@example.com"
       required>

<!-- Benefits: --&gt;
<!-- - Built-in email format validation --&gt;
<!-- - Mobile keyboards show @ and .com --&gt;
<!-- - Multiple emails with 'multiple' attribute --&gt;`;

    const inputPasswordCode = `<label for="password">Password:</label>
<input type="password" 
       id="password" 
       name="password" 
       minlength="8"
       pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
       title="Must contain at least one number, one uppercase and lowercase letter, and at least 8 characters"
       required>

<!-- Features: --&gt;
<!-- - Text is masked () --&gt;
<!-- - Not saved in browser history --&gt;
<!-- - Autocomplete can be controlled --&gt;`;

    const inputTelCode = `<label for="phone">Phone:</label>
<input type="tel" 
       id="phone" 
       name="phone" 
       placeholder="+1 (555) 000-0000"
       pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}">

<!-- Benefits: --&gt;
<!-- - Mobile keyboards show numeric keypad --&gt;
<!-- - No built-in validation (use pattern) --&gt;`;

    const inputUrlCode = `<label for="website">Website:</label>
<input type="url" 
       id="website" 
       name="website" 
       placeholder="https://example.com"
       required>

<!-- Features: --&gt;
<!-- - Validates URL format --&gt;
<!-- - Mobile keyboards show .com and / --&gt;`;

    const inputSearchCode = `<label for="search">Search:</label>
<input type="search" 
       id="search" 
       name="q" 
       placeholder="Search...">

<!-- Features: --&gt;
<!-- - Shows clear button () when typing --&gt;
<!-- - Better semantics for search --&gt;`;

    const inputNumberCode = `<label for="quantity">Quantity:</label>
<input type="number" 
       id="quantity" 
       name="quantity" 
       min="1" 
       max="100" 
       step="1" 
       value="1"
       required>

<!-- Attributes: --&gt;
<!-- min: Minimum value --&gt;
<!-- max: Maximum value --&gt;
<!-- step: Increment/decrement amount --&gt;
<!-- value: Default value --&gt;

<!-- Mobile keyboard: Numeric --&gt;`;

    const inputRangeCode = `<label for="volume">Volume:</label>
<input type="range" 
       id="volume" 
       name="volume" 
       min="0" 
       max="100" 
       step="5" 
       value="50">
<output for="volume" id="volume-output">50</output>

<script>
const range = document.getElementById('volume');
const output = document.getElementById('volume-output');

range.addEventListener('input', (e) => {
    output.textContent = e.target.value;
});
</script>`;

    const inputDateCode = `<label for="birthday">Birthday:</label>
<input type="date" 
       id="birthday" 
       name="birthday" 
       min="1900-01-01" 
       max="2024-12-31"
       required>

<!-- Format: YYYY-MM-DD --&gt;
<!-- Opens date picker on click --&gt;`;

    const inputTimeCode = `<label for="appointment">Appointment Time:</label>
<input type="time" 
       id="appointment" 
       name="appointment" 
       min="09:00" 
       max="18:00"
       required>

<!-- Format: HH:MM (24-hour) --&gt;
<!-- Opens time picker --&gt;`;

    const inputDateTimeLocalCode = `<label for="meeting">Meeting:</label>
<input type="datetime-local" 
       id="meeting" 
       name="meeting"
       required>

<!-- Format: YYYY-MM-DDTHH:MM --&gt;
<!-- Date and time in one input --&gt;`;

    const inputMonthCode = `<label for="credit-exp">Card Expiry:</label>
<input type="month" 
       id="credit-exp" 
       name="credit-exp"
       min="2024-01"
       required>

<!-- Format: YYYY-MM --&gt;`;

    const inputWeekCode = `<label for="week">Select Week:</label>
<input type="week" 
       id="week" 
       name="week">

<!-- Format: YYYY-W## --&gt;`;

    const inputCheckboxCode = `<input type="checkbox" 
       id="subscribe" 
       name="subscribe" 
       value="yes"
       checked>
<label for="subscribe">Subscribe to newsletter</label>

<!-- Multiple checkboxes with same name --&gt;
<fieldset>
    <legend>Interests:</legend>
    <input type="checkbox" id="html" name="interests" value="html">
    <label for="html">HTML</label>
    
    <input type="checkbox" id="css" name="interests" value="css">
    <label for="css">CSS</label>
    
    <input type="checkbox" id="js" name="interests" value="js" checked>
    <label for="js">JavaScript</label>
</fieldset>`;

    const inputRadioCode = `<fieldset>
    <legend>Choose payment method:</legend>
    
    <input type="radio" id="credit" name="payment" value="credit" checked>
    <label for="credit">Credit Card</label>
    
    <input type="radio" id="debit" name="payment" value="debit">
    <label for="debit">Debit Card</label>
    
    <input type="radio" id="paypal" name="payment" value="paypal">
    <label for="paypal">PayPal</label>
</fieldset>

<!-- All radio buttons with same 'name' = only one selectable --&gt;`;

    const inputFileCode = `<label for="avatar">Choose profile picture:</label>
<input type="file" 
       id="avatar" 
       name="avatar" 
       accept="image/png, image/jpeg"
       required>

<!-- Multiple files --&gt;
<label for="photos">Upload photos:</label>
<input type="file" 
       id="photos" 
       name="photos" 
       accept="image/*"
       multiple>

<!-- accept attribute: --&gt;
<!-- image/* - All images --&gt;
<!-- image/png, image/jpeg - Specific types --&gt;
<!-- .pdf, .doc - File extensions --&gt;
<!-- audio/*, video/* - Audio/video files --&gt;`;

    const inputColorCode = `<label for="favcolor">Favorite Color:</label>
<input type="color" 
       id="favcolor" 
       name="favcolor" 
       value="#ff0000">

<!-- Value must be in hex format (#RRGGBB) --&gt;
<!-- Opens color picker --&gt;`;

    const inputSubmitCode = `<input type="submit" value="Submit Form">
<!-- Or --&gt;
<button type="submit">Submit Form</button>

<!-- Submits the form --&gt;`;

    const inputButtonCode = `<input type="button" value="Click Me" onclick="doSomething()">
<!-- Or --&gt;
<button type="button" onclick="doSomething()">Click Me</button>

<!-- Does nothing by default (use JavaScript) --&gt;`;

    const inputResetCode = `<input type="reset" value="Clear Form">
<!-- Or --&gt;
<button type="reset">Clear Form</button>

<!-- Resets all form fields to default values --&gt;`;

    const inputImageCode = `<input type="image" 
       src="submit-button.png" 
       alt="Submit" 
       width="100" 
       height="40">

<!-- Acts as submit button --&gt;
<!-- Sends x,y coordinates of click --&gt;`;

    const inputHiddenCode = `<input type="hidden" name="user_id" value="12345">
<input type="hidden" name="csrf_token" value="abc123xyz">

<!-- Not visible to user --&gt;
<!-- Submitted with form --&gt;
<!-- Use for: IDs, tokens, tracking data --&gt;`;

    const validationAttrsCode = `<input type="text" 
       required                    <!-- Field must be filled --&gt;
       minlength="3"               <!-- Minimum length --&gt;
       maxlength="50"              <!-- Maximum length --&gt;
       pattern="[A-Za-z]{3,}"      <!-- Regex pattern --&gt;
       title="Username must be at least 3 letters">  <!-- Tooltip --&gt;`;

    const usabilityAttrsCode = `<input type="text" 
       placeholder="Enter text..."     <!-- Hint text --&gt;
       value="Default value"           <!-- Initial value --&gt;
       disabled                        <!-- Cannot interact --&gt;
       readonly                        <!-- Cannot edit --&gt;
       autofocus                       <!-- Focus on page load --&gt;
       autocomplete="name"             <!-- Autocomplete hint --&gt;
       spellcheck="true">              <!-- Enable spellcheck --&gt;`;

    return (
        <div className="premium-course-content">
            <div className="content-hero">
                <div className="hero-badge">Forms & Input</div>
                <h1>Input Types (text, email, password, number)</h1>
                <p className="hero-lead">
                    Master HTML5 input types for better user experience and built-in validation. Learn all
                    input types, their attributes, and when to use each one.
                </p>
            </div>

            <div className="content-section">
                <h2>HTML5 Input Types Overview</h2>
                <p>
                    HTML5 introduced many specialized input types with built-in validation and mobile-optimized keyboards.
                </p>

                <div className="input-types-grid">
                    <div className="type-card">
                        <h3>Text Inputs</h3>
                        <ul>
                            <li>text</li>
                            <li>email</li>
                            <li>tel</li>
                            <li>url</li>
                            <li>search</li>
                            <li>password</li>
                        </ul>
                    </div>
                    <div className="type-card">
                        <h3>Numeric Inputs</h3>
                        <ul>
                            <li>number</li>
                            <li>range</li>
                        </ul>
                    </div>
                    <div className="type-card">
                        <h3>Date/Time Inputs</h3>
                        <ul>
                            <li>date</li>
                            <li>time</li>
                            <li>datetime-local</li>
                            <li>month</li>
                            <li>week</li>
                        </ul>
                    </div>
                    <div className="type-card">
                        <h3>Selection Inputs</h3>
                        <ul>
                            <li>checkbox</li>
                            <li>radio</li>
                            <li>file</li>
                            <li>color</li>
                        </ul>
                    </div>
                    <div className="type-card">
                        <h3>Buttons</h3>
                        <ul>
                            <li>button</li>
                            <li>submit</li>
                            <li>reset</li>
                            <li>image</li>
                        </ul>
                    </div>
                    <div className="type-card">
                        <h3>Hidden</h3>
                        <ul>
                            <li>hidden</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="content-section">
                <h2>Text Input Types</h2>

                <h3>1. type="text" (Default)</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputTextCode} />
                </div>

                <h3>2. type="email"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputEmailCode} />
                </div>

                <h3>3. type="password"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputPasswordCode} />
                </div>

                <h3>4. type="tel"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputTelCode} />
                </div>

                <h3>5. type="url"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputUrlCode} />
                </div>

                <h3>6. type="search"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputSearchCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Numeric Input Types</h2>

                <h3>1. type="number"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputNumberCode} />
                </div>

                <h3>2. type="range" (Slider)</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputRangeCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Date and Time Inputs</h2>

                <h3>1. type="date"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputDateCode} />
                </div>

                <h3>2. type="time"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputTimeCode} />
                </div>

                <h3>3. type="datetime-local"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputDateTimeLocalCode} />
                </div>

                <h3>4. type="month"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputMonthCode} />
                </div>

                <h3>5. type="week"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputWeekCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Selection Inputs</h2>

                <h3>1. type="checkbox"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputCheckboxCode} />
                </div>

                <h3>2. type="radio"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputRadioCode} />
                </div>

                <h3>3. type="file"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputFileCode} />
                </div>

                <h3>4. type="color"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputColorCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Button Types</h2>

                <h3>1. type="submit"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputSubmitCode} />
                </div>

                <h3>2. type="button"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputButtonCode} />
                </div>

                <h3>3. type="reset"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputResetCode} />
                </div>

                <h3>4. type="image"</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={inputImageCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>type="hidden"</h2>
                <div className="code-example">
                    <CodeBlock language="html" code={inputHiddenCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Common Attributes</h2>

                <h3>Validation Attributes</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={validationAttrsCode} />
                </div>

                <h3>Usability Attributes</h3>
                <div className="code-example">
                    <CodeBlock language="html" code={usabilityAttrsCode} />
                </div>
            </div>

            <div className="content-section">
                <h2>Input Type Selection Guide</h2>
                <div className="selection-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Data Type</th>
                                <th>Use This Input</th>
                                <th>Why</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Name, Address</td>
                                <td><code>text</code></td>
                                <td>General text entry</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td><code>email</code></td>
                                <td>Built-in validation, optimized keyboard</td>
                            </tr>
                            <tr>
                                <td>Phone</td>
                                <td><code>tel</code></td>
                                <td>Numeric keyboard on mobile</td>
                            </tr>
                            <tr>
                                <td>Password</td>
                                <td><code>password</code></td>
                                <td>Masked text</td>
                            </tr>
                            <tr>
                                <td>Age, Quantity</td>
                                <td><code>number</code></td>
                                <td>Numeric input with controls</td>
                            </tr>
                            <tr>
                                <td>Birth Date</td>
                                <td><code>date</code></td>
                                <td>Date picker</td>
                            </tr>
                            <tr>
                                <td>Yes/No</td>
                                <td><code>checkbox</code></td>
                                <td>Single toggle</td>
                            </tr>
                            <tr>
                                <td>One choice</td>
                                <td><code>radio</code></td>
                                <td>Single selection from group</td>
                            </tr>
                            <tr>
                                <td>File Upload</td>
                                <td><code>file</code></td>
                                <td>File selection</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content-section">
                <h2>Best Practices</h2>
                <div className="best-practices-grid">
                    <div className="practice-card">
                        <h3>Do</h3>
                        <ul>
                            <li>Use specific input types (email, tel, date)</li>
                            <li>Add labels to every input</li>
                            <li>Use placeholder for hints, not labels</li>
                            <li>Include validation attributes</li>
                            <li>Test on mobile devices</li>
                            <li>Use autocomplete attributes</li>
                            <li>Provide clear error messages</li>
                        </ul>
                    </div>
                    <div className="practice-card error">
                        <h3> Don't</h3>
                        <ul>
                            <li>Use text for everything</li>
                            <li>Forget labels</li>
                            <li>Use placeholder as label</li>
                            <li>Rely only on client-side validation</li>
                            <li>Make required fields unclear</li>
                            <li>Disable autocomplete unnecessarily</li>
                            <li>Use cryptic error messages</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default HTMLInputTypes;



